import { useState } from "react";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { CheckBadgeIcon } from "@heroicons/react/16/solid";
import { useNavigate } from "react-router-dom";
import PhysicalProcedureImage from "../../Images/Group 414.png";
import VirtualizationProcedureImage from "../../Images/Group 416.png";
import { useDispatch, useSelector } from "react-redux";
import { setProcedureType } from "../../features/modal/modalSlices/ProcedureSlice";
import { selectPdEId } from "../property/propertySlice";
import { selectPDEInfo } from "../user/userSlice";
import { selectProcedureMod } from "../Modify/ModifySlice";
import ConfirmationModal from "./ConfirmationModal";

export default function VirtualOrPhysicalModal() {
  const [open, setOpen] = useState(true);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [selectedProcedure, setSelectedProcedure] = useState(null);
  const [language, setLanguage] = useState("English");

  const disableVirtualAndPaperless = true;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const pde = useSelector(selectPdEId);
  const pdeInfo = useSelector(selectPDEInfo);
  const procedureMod = useSelector(selectProcedureMod);

  const prevProcType = pdeInfo.pdeData[0].appointment_Type;

  const handleSelectProcedure = (appointmentType) => {
    setSelectedProcedure(appointmentType);

    if (pde) {
      if (procedureMod && prevProcType === "P" && appointmentType === "V") {
        setIsConfirmationOpen(true);
      } else if (
        procedureMod &&
        prevProcType === "V" &&
        appointmentType === "P"
      ) {
        proceedToNext(appointmentType);
      } else {
        proceedToNext(appointmentType);
      }
    }
  };

  const handleProceed = () => {
    sessionStorage.removeItem("datatableEntries");
    sessionStorage.removeItem("datatableEntries2");
    sessionStorage.removeItem("datatableEntriesWitness");

    proceedToNext(selectedProcedure);
    setIsConfirmationOpen(false);
  };

  const handleCloseConfirmationModal = () => {
    setIsConfirmationOpen(false);
  };

  const proceedToNext = (appointmentType) => {
    dispatch(setProcedureType(appointmentType));
    navigate("/PartyDetails");
  };

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  return (
    <div>
      <Transition show={open}>
        <Dialog
          className="relative z-10"
          onClose={() => {
            if (!isConfirmationOpen) {
              setOpen(true);
            }
          }}
          static // This ensures the modal cannot be closed by clicking outside
        >
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
              <TransitionChild
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <DialogPanel className="relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                  <div className="bg-white">
                    <div className="flex justify-center m-4 mt-4">
                      <CheckBadgeIcon
                        className="h-6 w-6 text-green-600"
                        aria-hidden="true"
                      />
                      <div className="ml-2">
                        <DialogTitle
                          as="h3"
                          className="text-md font-semibold text-gray-900"
                        >
                          <span className="text-green-600">WELL DONE</span>!
                          PROPERTY DETAILS AND PROPERTY EVALUATION HAS RECORDED
                          SUCCESSFULLY
                        </DialogTitle>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-100 m-6 p-4">
                    <div className="flex items-center">
                      <h6 className="text-red-700 font-semibold mr-4">
                        IMPORTANT ANNOUNCEMENT
                      </h6>
                      <input
                        type="radio"
                        name="language"
                        value="English"
                        checked={language === "English"}
                        onChange={handleLanguageChange}
                        className="mr-2"
                      />
                      <span className="text-sm font-semibold text-gray-900 mr-4">
                        English
                      </span>
                      <input
                        type="radio"
                        name="language"
                        value="Hindi"
                        checked={language === "Hindi"}
                        onChange={handleLanguageChange}
                        className="mr-2"
                      />
                      <span className="text-sm font-semibold text-gray-900">
                        Hindi
                      </span>
                    </div>
                    <div className="text-gray-900 mt-0.5 text-xs">
                      {language === "English" ? (
                        <p>
                          The Uttarakhand government has initiated an updated
                          Public Data Entry (PDE) system, a significant step
                          towards modernizing property management and enhancing
                          transparency. This new system introduces a
                          groundbreaking flow, effective from July 25, 2024,
                          that leverages the Aadhaar card to gather
                          comprehensive property details. The integration of
                          Aadhaar, India's unique identification system, ensures
                          accuracy and authenticity in data collection,
                          minimizing discrepancies and fraudulent activities.
                          The property virtualization feature within the PDE
                          system digitizes property records, making them easily
                          accessible and manageable for both government
                          officials and property owners. This move not only
                          streamlines the process of property registration and
                          management but also facilitates better governance
                          through real-time data availability. Property owners
                          can now verify and update their property information
                          with ease, leading to a more efficient and
                          user-friendly experience. Additionally, this
                          initiative aligns with the government's vision of a
                          Digital India, promoting digital infrastructure and
                          services at the grassroots level. By centralizing
                          property data and linking it to Aadhaar, the
                          Uttarakhand government is paving the way for a more
                          transparent, accountable, and efficient property
                          management system that benefits all stakeholders
                          involved.
                        </p>
                      ) : (
                        <p>
                          उत्तराखंड सरकार ने एक अपडेटेड सार्वजनिक डेटा प्रविष्टि
                          (पीडीई) प्रणाली शुरू की है, जो संपत्ति प्रबंधन को
                          आधुनिक बनाने और पारदर्शिता बढ़ाने की दिशा में एक
                          महत्वपूर्ण कदम है। यह नई प्रणाली 25 जुलाई, 2024 से
                          प्रभावी होने वाले एक नए प्रवाह की शुरुआत करती है, जो
                          संपत्ति विवरण इकट्ठा करने के लिए आधार कार्ड का उपयोग
                          करती है। आधार, भारत की अद्वितीय पहचान प्रणाली, का
                          एकीकरण डेटा संग्रह में सटीकता और प्रामाणिकता सुनिश्चित
                          करता है, जिससे विसंगतियों और धोखाधड़ी की गतिविधियों को
                          कम किया जा सके। पीडीई प्रणाली के भीतर संपत्ति
                          वर्चुअलाइजेशन सुविधा संपत्ति रिकॉर्ड को डिजिटाइज़ करती
                          है, जिससे उन्हें सरकारी अधिकारियों और संपत्ति मालिकों
                          दोनों के लिए आसानी से सुलभ और प्रबंधनीय बनाया जा सके।
                          यह कदम न केवल संपत्ति पंजीकरण और प्रबंधन की प्रक्रिया
                          को सुव्यवस्थित करता है बल्कि वास्तविक समय डेटा
                          उपलब्धता के माध्यम से बेहतर शासन की सुविधा भी प्रदान
                          करता है। संपत्ति मालिक अब अपने संपत्ति की जानकारी को
                          आसानी से सत्यापित और अपडेट कर सकते हैं, जिससे एक अधिक
                          कुशल और उपयोगकर्ता के अनुकूल अनुभव प्राप्त होता है।
                          इसके अतिरिक्त, यह पहल डिजिटल इंडिया के सरकार के
                          दृष्टिकोण के साथ संरेखित होती है, जो जमीनी स्तर पर
                          डिजिटल अवसंरचना और सेवाओं को बढ़ावा देती है। संपत्ति
                          डेटा को केंद्रीकृत करके और इसे आधार से जोड़कर,
                          उत्तराखंड सरकार एक अधिक पारदर्शी, जिम्मेदार और कुशल
                          संपत्ति प्रबंधन प्रणाली के लिए मार्ग प्रशस्त कर रही
                          है, जिससे इसमें शामिल सभी हितधारकों को लाभ होता है।
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="bg-white m-6">
                    <h3 className="text-md font-medium leading-6 text-gray-900 items-start">
                      CONTINUE PDE WITH..
                    </h3>
                    <div className="flex justify-center m-4">
                      {/* <div
                        className="mx-4 cursor-pointer"
                        onClick={() => handleSelectProcedure("P")}
                      > */}
                      <div
                        className={`mx-8 ${
                          disableVirtualAndPaperless
                            ? "opacity-50 pointer-events-none cursor-not-allowed"
                            : "cursor-pointer"
                        }`}
                      >
                        <img
                          src={PhysicalProcedureImage}
                          alt="Physical procedure"
                          className="w-30 h-30"
                        />
                        <p className="">Physical procedure</p>
                      </div>
                      {/* <div
                        className="mx-8 cursor-pointer"
                        onClick={() => handleSelectProcedure("V")}
                      > */}
                      <div
                        className={`mx-8 ${
                          disableVirtualAndPaperless
                            ? "opacity-50 pointer-events-none cursor-not-allowed"
                            : "cursor-pointer"
                        }`}
                        onClick={() => {
                          if (!disableVirtualAndPaperless)
                            handleSelectProcedure("V");
                        }}
                      >
                        <img
                          src={VirtualizationProcedureImage}
                          alt="Virtualization procedure"
                          className="w-30 h-30"
                        />
                        <p className="">Virtualization procedure</p>
                      </div>
                      <div
                        className="mx-8 cursor-pointer"
                        onClick={() => handleSelectProcedure("L")}
                      >
                        <img
                          src={VirtualizationProcedureImage}
                          alt="Paperless procedure"
                          className="w-30 h-30"
                        />
                        <p className="">Paperless procedure</p>
                      </div>
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>

      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={isConfirmationOpen}
        onClose={handleCloseConfirmationModal}
        onProceed={handleProceed}
        message="Switching the procedure type will clear all Party Detail data. Are you sure you want to proceed?"
      />
    </div>
  );
}
